import { useEffect, useState } from "react";
import { useParams, Navigate, useSearchParams } from "react-router-dom";
import { useSocket } from "../context/SocketContext";
import { decryptData, encryptData } from "../helpers/cryptoSocketData";
import { useDispatch, useSelector } from "react-redux";
import { getRooms } from "../store/roomSlice";

// const validRoomIds = ["1", "2", "3", "4", "5", "6"];

const RoomValidator = ({ children }) => {
  const { roomId } = useParams();
  const { rooms, loading: roomsLoading, loaded: roomsLoaded } = useSelector((state) => state.room);
  const dispatch = useDispatch();
  const validRoomIds = rooms.map((room) => room.id);
  const username = JSON.parse(sessionStorage.getItem("username"))
  const userId = JSON.parse(sessionStorage.getItem("userId"))
  const socket = useSocket();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isValidated, setIsValidated] = useState(false);

  useEffect(() => {
    if (!roomsLoaded) {
     dispatch(getRooms());
    }
  }, [dispatch, roomsLoaded]);

  useEffect(() => {
    if (socket) {
      const checkRoomCapacity = () => {
        socket.emit(
          "check-room-capacity",
          encryptData(JSON.stringify({ roomId, username, userId }))
        );
      };

      socket.on("room-capacity-status", (data) => {
        const decryptedData = decryptData(data);
        if (decryptedData.isFull) {
          setError(
            `Room is Full`
          );
          setIsValidated(false);
        } else if (decryptedData.message) {
          setError(decryptedData.message);
          setIsValidated(false);
        } else {
          setIsValidated(true);
        }
        setIsLoading(false);
      });
      checkRoomCapacity();

      return () => {
        socket.off("room-capacity-status");
      };
    }
  }, [socket]);
  
  if (roomsLoading || rooms.length === 0) {
    return (
      <div className="main-box">
        <div className="flex items-center justify-center return-lobby">
          <h2 className="mb-4">Joining the room, please wait...</h2>
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  if (!validRoomIds.includes(Number(roomId))) {
    return <Navigate to="/notfound" />;
  }

  if (isLoading) {
    return (
      <div className="main-box">
        <div className="flex items-center justify-center return-lobby">
          <h2 className="mb-4">Checking room availability</h2>
          <div className="loader"></div>
        </div>
      </div>
    );
  }
  

  if (error || !isValidated) {
    return (
      <Navigate
        to="/invalid"
        state={{ error: error || "Access denied" }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default RoomValidator;
